import classnames from 'classnames'
import ApiClient from 'clients/api_client'
import Toast from 'components/toast'
import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import Modal from 'react-overlays/lib/Modal'
import { setModalStyle } from 'supports/modal_style_helper'

export default class OfferDeleteModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      show: false
    }
  }

  show() {
    this.setState({
      show: true
    })
  }

  hide() {
    this.setState({
      show: false
    })
  }

  handleSubmit() {
    const { offerId } = this.props
    const url = Routes.offerPath(offerId)

    this.setState({
      loading: true
    })

    ApiClient.delete(url)
      .then(() => {
        window.location.href = Routes.offersPath()
      })
      .catch(() => {
        Toast.notify(I18n.t('common.message.delete.failure'))
        this.setState({
          loading: false
        })
      })
  }

  render() {
    const { loading, show } = this.state
    const btnClassName = classnames('btn', 'btn-delete', {
      'is-disabled': loading
    })

    return (
      <Fragment>
        <button type="button" className="btn btn-danger" onClick={() => this.show()}>
          {I18n.t('components.offer_delete_modal.button.delete')}
        </button>
        <Modal show={show} onShow={() => setModalStyle(this.modal)}>
          <div className="modal modal-delete">
            <div className="modal-bg" onClick={() => this.hide()} role="presentation" />
            <div
              className="modal-in"
              ref={ref => {
                this.modal = ref
              }}
            >
              <div className="modal-header">
                <div className="title">{I18n.t('components.offer_delete_modal.title')}</div>
              </div>
              <div className="modal-content">
                <div className="modal-form">
                  <div>
                    {I18n.t('components.offer_delete_modal.message.delete.description.1')}
                    <br />
                    {I18n.t('components.offer_delete_modal.message.delete.description.2')}
                    <br />
                    {I18n.t('components.offer_delete_modal.message.delete.confirm')}
                  </div>
                </div>
                <div className="modal-submit">
                  <button type="button" className={btnClassName} onClick={() => this.handleSubmit()} disabled={loading}>
                    {loading ? I18n.t('components.offer_delete_modal.button.deleting') : I18n.t('common.button.delete')}
                  </button>
                  <button type="button" className="btn btn-default" onClick={() => this.hide()}>
                    {I18n.t('common.button.cancel')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    )
  }
}

OfferDeleteModal.propTypes = {
  offerId: PropTypes.number.isRequired
}
